module.exports = __webpack_public_path__ + "assets/img/electric.07bb9cae.png";